import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import HistoryLocation from '../../assets/history_location.svg';
import { useLocation } from 'react-router-dom';
import GiftItem2 from '../../assets/GiftAsset/GiftItem1.jpg';
import Action from '../../assets/action-button.svg';
import ActionPopper from './ActionPopper';



function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const {pathname} = useLocation()
  const path_link = pathname.includes('digital-courses')
  console.log(path_link)
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        {path_link? <></>:
        <>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.orderId}
        </TableCell>
        </>
          }
        <TableCell align="center">{row.category}</TableCell>
        <TableCell align="center">{row.datePurchased}</TableCell>
        <TableCell align="center">₦{row.grandTotal}</TableCell>
        <TableCell align="center" sx={{fontWeight:'600'}}>₦1{row.walletBalance}</TableCell>
        <TableCell>
            <Typography sx={{
                color:row.status.toLowerCase()==='confirmed'?'rgba(38, 155, 143, 1)':row.status==='failed'?'rgba(254, 0, 0, 1)':'rgba(235, 250, 249, 1)',
                backgroundColor:row.status.toLowerCase()==='confirmed'?'rgba(191, 240, 235, 1)':row.status==='failed'?'rgba(254, 0, 0, 0.2)':'rgba(18, 113, 35, 1)',
                border:`1px solid ${row.status.toLowerCase()==='confirmed'?'rgba(191, 240, 235, 1)':row.status==='failed'?'rgba(254, 0, 0, 0.2)':'rgba(235, 250, 249, 1)'}`,
                textAlign:'center',
                minWidth:'fit-content',
                borderRadius:'8px',
                p:1
                }}>{row.status}
            </Typography>
        </TableCell>
        <TableCell align="center"> <ActionPopper item_details={row}/></TableCell>
      </TableRow>
      {row?.category.toLowerCase() === 'gift shop'?
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases" sx={{backgroundColor:'#fff', borderRadius:'24px'}}>
                <TableHead>
                  <TableRow sx={{backgroundColor:'rgba(241, 240, 242, 1)', borderRadius:'24px 24px 0 0'}}>
                    <TableCell sx={{borderBottom:'none', fontWeight:'600', py:2, borderRadius:'24px 0 0 0'}}>Delivery Address</TableCell>
                    <TableCell sx={{borderBottom:'none',fontWeight:'600', py:2}}>Tracking Number</TableCell>
                    <TableCell sx={{borderBottom:'none',fontWeight:'600', py:2}} align="left">Product</TableCell>
                    <TableCell sx={{borderBottom:'none',fontWeight:'600', py:2,}} align="left">Qty</TableCell>
                    <TableCell sx={{borderBottom:'none',fontWeight:'600', py:2}} align="left">Price (Per Unit)</TableCell>
                    <TableCell sx={{borderBottom:'none',fontWeight:'600', py:2, borderRadius:'0 24px 0 0'}} align="left">Total price (N)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow sx={{backgroundColor:'rgba(255, 255, 255, 1)'}}>
                      <TableCell component="th" scope="row" sx={{borderBottom:'none', borderRadius:'0 0 0 24px', display:'flex', gap:2}}>
                        <img src={HistoryLocation} alt="location icon" />
                        <Typography>{row.deliveryAddress}</Typography>
                      </TableCell>
                      <TableCell sx={{borderBottom:'none'}}>{row.pricePerUnit}</TableCell>
                      <TableCell align="left" sx={{display:'flex', gap:2, borderBottom:'none'}}>
                        <img src= {GiftItem2} alt="gift item" style={{width:'80px', height:'50px'}}/>
                        <Typography>{row.productName}</Typography>
                        </TableCell>
                      <TableCell align="left" sx={{borderBottom:'none'}}>{row.quantity}</TableCell>
                      <TableCell align="left" sx={{borderBottom:'none'}}>{row.grandTotal}</TableCell>
                      <TableCell align="left" sx={{borderBottom:'none', borderRadius:'0 0 24px 0'}}>{row.totalAmount}</TableCell>
                    </TableRow>
                </TableBody>
              </Table>
              <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'end', p:3, mt:3, border: '1px solid rgba(182, 183, 185, 1)', borderRadius:'24px'}}>
                <Box>
                    <Typography sx={{my:2, display:'flex', gap:2}}>
                        <span>
                        Sub-Total
                        </span>
                        <span>
                        {row.subTotal}
                        </span>
                    </Typography>
                    <Typography sx={{my:2, display:'flex', gap:2}}>
                        <span>
                            Discount
                        </span>
                        <span>
                        {row.discount}
                        </span>
                    </Typography>
                    <Typography sx={{my:2, display:'flex', gap:2}}>
                    <span>
                        Delivery Fee
                    </span>
                    <span>
                    {row.deliveryFee}
                    </span>
                    </Typography>
                </Box>
                <Typography variant='h6' sx={{display:'flex', gap:2, fontSize:'1.2rem'}}>
                    <span style={{color:'rgba(86, 4, 246, 1)'}}>
                        Grand Total
                    </span>
                    <span>
                        {row.grandTotal}
                    </span>
                </Typography>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>:
      <></>
        }
    </React.Fragment>
  );
}

export default function OrderHistoryTable({order_data}) {
  console.log(order_data)
  const {pathname} = useLocation()
  const path_link = pathname.includes('digital-courses')
  return (
    <TableContainer component={Paper} sx={{borderRadius:'24px', backgroundColor:'inherit'}}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow sx={{backgroundColor:'rgba(194, 195, 197, 1)'}}>
            {path_link?<></>:
            <>
            <TableCell />
            <TableCell sx={{fontWeight:'600'}}>Order Id</TableCell>
            </>
            } 
            <TableCell align="center" sx={{fontWeight:'600'}}>Category</TableCell>
            <TableCell align="center" sx={{fontWeight:'600'}}>Date and Time Purchased</TableCell>
            <TableCell align="center" sx={{fontWeight:'600'}}>Total Amount</TableCell>
            <TableCell align="center" sx={{fontWeight:'600'}}>Wallet Balance</TableCell>
            <TableCell align="center" sx={{fontWeight:'600'}}>Status</TableCell>
            <TableCell align="center" sx={{fontWeight:'600'}}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {order_data?.map((row) => (
            <Row key={row.name} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
